module.exports = __webpack_public_path__ + "img/logo-transportistasurbanos.5434582e.png";